export const START = 'START';
export const QUOTING = 'QUOTING';
export const QUOTED = 'QUOTED';
export const PRICE_SELECTED = 'PRICE_SELECTED';
export const ERROR = 'ERROR';
